// components/tutorial/tutorial-progress.tsx
// Wrapper around @vllnt/ui ProgressBar for tutorial-specific use
"use client";

import { memo } from "react";

import { ProgressBar } from "@vllnt/ui";

export type TutorialProgressProps = {
  completionCount: number;
  isComplete: boolean;
  isLoading?: boolean;
  label: string;
  sectionsLabel: string;
  totalSections: number;
};

function TutorialProgressImpl({
  completionCount,
  isComplete,
  isLoading = false,
  label,
  sectionsLabel,
  totalSections,
}: TutorialProgressProps): React.ReactNode {
  return (
    <ProgressBar
      completedLabel={sectionsLabel}
      currentLabel={label}
      isComplete={isComplete}
      isLoading={isLoading}
      max={totalSections}
      value={completionCount}
    />
  );
}

export const TutorialProgress = memo(TutorialProgressImpl);
TutorialProgress.displayName = "TutorialProgress";
